import moment, {Moment} from "moment";

export interface User {
  _id: any;
  full_name: string;
}

export interface Order {
  _id: any;
  number: string;
  notes: string;
  created_at: Moment;
  updated_at: Moment;
  items: Item[];
  allocated_to?: User;
}

export interface Money {
  cents: number;
  currency_iso: string;
}

export interface Item {
  _id: any;
  number: number;
  name: string;
  adjustment: Money;
  components: Component[];
  adjusted_price: Money;
  cost: Money;
  ready_to_fit: boolean;
  completed: boolean;
  [key: string]: any;
}

export interface Product {
  _id: any;
  name: string;
  description: string;
}

export interface Distance {
  micrometres: number;
}

export interface StockOrder {
  po_placed?: string;
  po_received?: string;
  po_reference?: string;

}

export interface Component {
  id: string;
  product: Product;
  number: number;
  quantity: number;
  length_distance: string;
  width_distance: string;
  length: Distance;
  width: Distance;
  square_metre: number;
  bulk_purchase: boolean;
  product_cost: Money;
  product_price: Money;
  product_description: string;
  stock_order?: StockOrder;
}

export function parseOrder(data: any) {
  const order = data as Order;
  order.created_at = moment(data.created_at);
  order.updated_at =  moment(data.updated_at);
  return order;
}

export function blankOrder() {
  return {} as Order;
}
